import BestSellerComponent from "./BestSellerComponent.view";

export default BestSellerComponent;
